import GraficEleccions from 'components/3catinfo/Eleccions/Grafiques/GraficEleccions';
import Slider from 'components/3catinfo/Slider';
import __isEmpty from 'lodash/isEmpty';
import styles from './slidergrafics.module.scss';

const SliderGrafics = (props) => {
    const {
        items,
        baseURL,
        baseURLComparador,
        fase,
        textMostraMes,
        linkTipusMostraMes,
        tipusLlegenda,
        mostrarComparativa = true,
        tipus,
        intervalRefresh = 0,
        emitterId,
        peuMostraCamps,
        mostrarPartitsSenseDiputats,
        limitItems,
        descartarId
    } = props;

    const buildUrl = (base, id) => {
        if (!base) return null;
        return base.includes('[[id]]') ? base.replace('[[id]]', id) : `${base}${id}.json`;
    };
    const itemsRender = descartarId ? items?.filter((item) => parseInt(item.id) !== parseInt(descartarId)) : items;

    return (
        <>
            {itemsRender && (
                <Slider format='eleccionsGraficBarres' estil='eleccionsGraficBarres' estilModul='eleccions' fletxes='mig'>
                    {itemsRender.map((item, i) => (
                        <GraficEleccions
                            key={`grafic-${tipus}-${item.id}-${i}`}
                            titol={item.nom}
                            urlDades={buildUrl(baseURL, item.id)}
                            urlDadesComparador={buildUrl(baseURLComparador, item.id)}
                            fase={fase}
                            textMostraMes={textMostraMes}
                            linkTipusMostraMes={linkTipusMostraMes}
                            tipusLlegenda={tipusLlegenda}
                            estilLlegenda='slider'
                            mostrarComparativa={mostrarComparativa}
                            tipus={tipus}
                            intervalRefresh={intervalRefresh}
                            emitterId={emitterId}
                            id={item.id}
                            slug={item.nom}
                            estil='slider'
                            mostrarPartitsSenseDiputats={mostrarPartitsSenseDiputats}
                            limitItems={limitItems}
                            className={styles.graficSlider}
                            peuMostraCamps={peuMostraCamps}
                        />
                    ))}
                </Slider>
            )}
        </>
    );
};

export default SliderGrafics;
